import {
    Box,
    Button,
    MenuItem,
    Stack,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TablePagination,
    TableRow,
    TextField,
    Typography,
} from '@mui/material'
import { useEffect, useState } from 'react'
import { DentalMarketingPlan } from '../services/models/inurance-plan'
import { getDentalProducts } from '../services/productService'
import { DataPanel } from './DataPanel'
import { DentalProductDetailsDialog } from './dialogs/eligibility/DentalProductDetailsDialog'

const ProductsTable = () => {
    const [tableData, setTableData] = useState<DentalMarketingPlan[]>([])
    const [productLine, setProductLine] = useState('DENTAL')
    const [page, setPage] = useState(0)
    const [recordCount, setRecordCount] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(5)
    const [dialogOpen, setDialogOpen] = useState(false)
    const [dialogData, setDialogData] = useState<DentalMarketingPlan | null>(null)
    const tableCellCss = { justifyContent: 'center' }
    const handleChangePage = (event: unknown, newPage: number) => {
        setPage(newPage)
    }

    const handleChangeRowsPerPage = (
        event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>,
    ) => {
        setRowsPerPage(+event.target.value)
        setPage(0)
    }
    useEffect(() => {
        const fetchProducts = async () => {
            const {
                data: { data, numberOfEntries },
            } = await getDentalProducts(page * rowsPerPage, rowsPerPage)
            setTableData(data ?? [])
            setRecordCount(numberOfEntries)
        }
        fetchProducts()
    }, [page, rowsPerPage])

    return (
        <>
            <>
                <DataPanel
                    content={
                        <>
                            <Box
                                sx={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    margin: 2,
                                    flexGrow: 1,
                                }}
                            >
                                <Box
                                    sx={{
                                        flexGrow: 1,
                                    }}
                                >
                                    <Stack
                                        direction="row"
                                        spacing={1}
                                        sx={{ alignItems: 'center', display: 'flex' }}
                                    >
                                        <Typography
                                            fontSize="medium"
                                            fontWeight="bold"
                                            marginRight={'10px'}
                                        >
                                            Product Type
                                        </Typography>
                                        <TextField
                                            select
                                            disabled
                                            value={productLine}
                                            onChange={(e) => setProductLine(e.target.value)}
                                        >
                                            <MenuItem value="DENTAL">Dental</MenuItem>
                                            <MenuItem value="MEDICAL">Medical</MenuItem>
                                            <MenuItem value="VISION">Vision</MenuItem>
                                        </TextField>
                                    </Stack>
                                </Box>
                                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                    <Button onClick={() => {}} disabled>
                                        Add New
                                    </Button>
                                </Box>
                            </Box>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>Plan Year</TableCell>
                                        <TableCell>Name</TableCell>
                                        <TableCell>Network</TableCell>
                                        <TableCell>Members</TableCell>
                                        <TableCell>Action</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {tableData.map((entry) => (
                                        <TableRow key={entry.id}>
                                            <TableCell align="center" sx={tableCellCss}>
                                                {entry.planYear}
                                            </TableCell>
                                            <TableCell align="center" sx={tableCellCss}>
                                                {entry.planName}
                                            </TableCell>
                                            <TableCell align="center" sx={tableCellCss}>
                                                {entry.networkName}
                                            </TableCell>
                                            <TableCell align="center" sx={tableCellCss}>
                                                0
                                            </TableCell>
                                            <TableCell align="center" sx={tableCellCss}>
                                                <Button
                                                    sx={{ borderRadius: 5 }}
                                                    onClick={() => {
                                                        setDialogData(entry)
                                                        setDialogOpen(true)
                                                    }}
                                                >
                                                    Details
                                                </Button>
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </>
                    }
                />
            </>
            <>
                <Box
                    sx={{
                        paddingTop: 1,
                        marginLeft: 2,
                        marginRight: 2,
                        alignItems: 'center',
                        display: 'flex',
                    }}
                >
                    <Box sx={{ flexGrow: 1 }}></Box>
                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                        <TablePagination
                            rowsPerPageOptions={[5, 10, 15, 20, 50, 100]}
                            component="div"
                            count={recordCount}
                            page={page}
                            onPageChange={handleChangePage}
                            rowsPerPage={rowsPerPage}
                            onRowsPerPageChange={handleChangeRowsPerPage}
                        />
                    </Box>
                </Box>
            </>
            <DentalProductDetailsDialog
                open={dialogOpen}
                onClose={() => setDialogOpen(false)}
                dentalProduct={dialogData as DentalMarketingPlan}
            />
        </>
    )
}

export default ProductsTable
